import { ALL_ROUTES } from '../constants/route-configs.constants'

export function isPublicRoute(pathname: string): boolean {
  if (!pathname) return false

  const publicRoutes = Object.values(ALL_ROUTES)
    .filter((route) => !route.requiresAuth)
    .map((route) => {
      const routePath = route.path.startsWith('/')
        ? route.path
        : `/${route.path}`
      return routePath
    })

  return publicRoutes.some((route) => {
    return pathname === route || pathname.startsWith(route)
  })
}
